import mapProps from "recompose/mapProps";
import useSelectedProductInformation from "./useSelectedProductInformation";

const withSelectedOptions = () =>
  mapProps(
    ({ product, selectedOptions: initialSelectedOptions = {}, ...props }) => {
      const {
        selectedSku,
        selectedProduct,
        selectedOptions,
        setSelectedOptions,
        setOption,
        baseProduct,
      } = useSelectedProductInformation(
        product,
        product.options,
        initialSelectedOptions
      );
      return {
        ...props,
        selectedSku,
        product: selectedProduct,
        selectedOptions,
        setSelectedOptions,
        setOption,
        baseProduct,
      };
    }
  );

export default withSelectedOptions;
